const Footer = () => {
  return (
    <footer
      className="py-12 border-t border-tc-border"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Tagline */}
          <div className="flex items-center gap-3">
            <img
              src="/tca-logo.png"
              alt="Traders Council Asia"
              className="h-10 w-auto"
            />
            <div>
              <p className="font-heading font-semibold text-white">Traders Council Asia Indonesia</p>
              <p className="text-sm text-tc-text-secondary">Edukasi • Disiplin • Kesadaran Risiko</p>
            </div>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8">
            <a
              href="https://t.me/+BGuUnb57hLxiZDk1"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-tc-text-secondary hover:text-white transition-colors"
            >
              Telegram
            </a>
            <a
              href="mailto:support@tradermatchup.com"
              className="text-sm text-tc-text-secondary hover:text-white transition-colors"
            >
              Kontak
            </a>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 pt-8 border-t border-tc-border">
          <p className="text-xs text-tc-text-secondary text-center max-w-3xl mx-auto">
            <strong className="text-tc-primary">Disclaimer:</strong> Trading mengandung risiko.
            Konten edukasi tidak menjamin profit. Kinerja masa lalu tidak menjamin hasil di masa depan.
            Seluruh materi di halaman ini bersifat edukasi dan bukan nasihat keuangan.
            Tradinglah secara bertanggung jawab dan gunakan modal yang siap rugi.
          </p>
        </div>

        {/* Copyright */}
        <p className="text-xs text-tc-text-secondary text-center mt-6">
          © {new Date().getFullYear()} Traders Council Asia Indonesia. Hak cipta dilindungi.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
